export const VIEW_ALL = 'VIEW ALL'
export const LESSON_MATERIALS_TITLE = 'Lesson Material PDFs'
export const BRAIN_BUILDER_ICON = 'brain_builder'
